module.exports = __webpack_public_path__ + "img/2.74fe1fe9.svg";